export const SUPPORTED_METADATA_TYPES = [
  'ApexClass',
  'ApexTrigger',
  'AuraDefinitionBundle',
  'Flow',
  'LightningComponentBundle',
  'ValidationRule',
  'Fields',
  'Records',
  'FlexCard',
  'DataMapper',
  'OmniScript',
  'OmniIntegrationProcedure'
];
